@if(lastArticle) {
<div class="full-width last-article">
  <div class="title">
    <p class="upper">
      {{ lastArticle.place }}, <em>{{ lastArticle.destination?.country }}</em>
    </p>
    <h2>{{ lastArticle.name }}</h2>
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a [href]="'/' + lastArticle.slug">
        <ng-container>Lire la suite</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </div>
  <div class="cover-wrapper">
    <img
      [alt]="lastArticle.coverPicture?.description"
      [ngSrc]="lastArticle.coverPicture!.src"
      fill
      priority
    />
  </div>
  <div class="separator">
    <span></span>
    <p class="upper">destinations</p>
  </div>
</div>

@if (destinations) {
<section class="discover column full-width">
  <h2>Pars à la découverte!</h2>
  <p class="m-auto">
    Ces destinations te feront voyager et découvrir nos explorations autour du monde!
  </p>
  <div
    class="wrapper"
    appSpot
    [icon]="'/icons/drag.svg'"
    [text]="'Drag'"
    [backgroundColor]="'#D17A2A'"
  >
    <div class="spot">
      <div class="discoveries" appDrag (dragging)="canClick = !$event">
        <a
          class="rectangle drag-child"
          *ngFor="let destination of destinations"
          [class.disabled]="!canClick"
          [href]="'/destination/' + destination.country"
        >
          <h2>{{ destination.country }}</h2>
          <img
            loading="lazy"
            [ngSrc]="destination.coverPicture.src"
            [alt]="destination.coverPicture.description"
            fill
          />
        </a>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a href="/destinations">
        <ng-container>Voir toutes nos destinations</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </div>
</section>
}

<div class="full-width">
  <app-ebook-section></app-ebook-section>
</div>

<div class="full-width about-us">
  <div class="row container m-auto">
    <section class="column w-5 mr-1">
      <p class="upper">à propos de nous</p>
      <h2>Explorer hors des sentiers battus et s'émerveiller de la beauté de notre planète</h2>
      <p class="ml-2">
        Nous sommes Estelle et Romain, un couple bruxellois amoureux de la nature. Nous aimons
        explorer notre Belgique et notre planète à la découverte des plus beaux paysages. Ici nous
        te partagerons nos explorations, nos coup de coeur, nos randonnées, nos conseils.
      </p>
      <div class="container">
        <div class="link">
          <img
            loading="lazy"
            class="icon"
            alt="plus"
            ngSrc="/icons/plus.svg"
            width="12"
            height="12"
          />
          <a href="/contact">
            <ng-container>Nous contacter</ng-container>
            <div class="line"></div>
          </a>
        </div>
      </div>
    </section>
    <div class="w-6 us" [class.w-12]="deviceService.isMobileOrTablet()">
      <img loading="lazy" alt="us" ngSrc="/home/us.jpg" width="1920" height="1280" />
    </div>
  </div>
</div>

<div class="accomodations full-width">
  <div class="separator">
    <span></span>
    <p class="upper">logements</p>
  </div>
  <div class="container m-auto">
    <h2>Nous avons découvert ces logements</h2>
    <div class="row">
      @if(deviceService.isMobileOrTablet()){
      <div class="accomodations-mobile">
        <app-accomodation-card [accomodation]="accomodations[0]"></app-accomodation-card>
        <app-accomodation-card [accomodation]="accomodations[1]"></app-accomodation-card>
        <app-accomodation-card [accomodation]="accomodations[2]"></app-accomodation-card>
      </div>
      } @else {
      <div class="w-7">
        <app-accomodation-card [accomodation]="accomodations[0]"></app-accomodation-card>
      </div>
      <div class="w-5">
        <app-accomodation-card
          [ratioX]="16"
          [ratioY]="9"
          [accomodation]="accomodations[1]"
        ></app-accomodation-card>
        <app-accomodation-card
          [ratioX]="16"
          [ratioY]="9"
          [accomodation]="accomodations[2]"
        ></app-accomodation-card>
      </div>
      }
    </div>
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a href="/logements">
        <ng-container>Voir tous les logements</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </div>
</div>

@if(discoverArticles){
<div class="container articles">
  <h2>Nos derniers articles</h2>
  <div class="row full-width">
    <app-article-card
      *ngFor="let article of discoverArticles"
      class="w-4"
      [class.w-6]="deviceService.isMobile()"
      [class.w-12]="deviceService.isTablet()"
      [article]="article"
    >
    </app-article-card>
  </div>
  <div class="container">
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a href="/articles">
        <ng-container>Tous nos articles</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </div>
</div>
}

<div class="full-width categories">
  <div class="container m-auto">
    <div class="w-10 m-auto" [class.w-12]="deviceService.isMobileOrTablet()">
      <section
        class="category-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@categoryAnimation]="hoverCategories['destinations'] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverCategory('destinations', true)"
        (mouseleave)="hoverCategory('destinations', false)"
        href="/destinations"
      >
        <div class="category-name">Destinations</div>
        <div class="number">01</div>
        <div
          class="image-container"
          [@categoryImageAnimation]="hoverCategories['destinations'] ? 'onHover' : 'onHide'"
        >
          <img loading="lazy" ngSrc="/home/destinations.jpg" alt="destinations" fill />
        </div>
      </section>
      <section
        class="category-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@categoryAnimation]="hoverCategories['belgium'] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverCategory('belgium', true)"
        (mouseleave)="hoverCategory('belgium', false)"
        (click)="navigateTo('/destination/Belgique')"
      >
        <div class="category-name">En Belgique</div>
        <div class="number">02</div>
        @if(belgiumDestination){
        <div
          class="image-container"
          [@categoryImageAnimation]="hoverCategories['belgium'] ? 'onHover' : 'onHide'"
          #container
        >
          <img loading="lazy" [ngSrc]="belgiumDestination.coverPicture!.src" alt="belgium" fill />
        </div>
        }
      </section>
      <section
        class="category-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@categoryAnimation]="hoverCategories['setup'] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverCategory('setup', true)"
        (mouseleave)="hoverCategory('setup', false)"
        (click)="navigateTo('/materiel')"
      >
        <div class="category-name">Matériel photo</div>
        <div class="number">03</div>
        <div
          class="image-container"
          [@categoryImageAnimation]="hoverCategories['setup'] ? 'onHover' : 'onHide'"
        >
          <img loading="lazy" ngSrc="/home/setup.jpg" alt="setup" fill />
        </div>
      </section>
      <section
        class="category-line"
        [class.disabled]="deviceService.isMobileOrTablet()"
        [@categoryAnimation]="hoverCategories['map'] ? 'onHover' : 'onHide'"
        (mouseenter)="hoverCategory('map', true)"
        (mouseleave)="hoverCategory('map', false)"
        (click)="navigateTo('/carte')"
      >
        <div class="category-name">Carte</div>
        <div class="number">04</div>
        <div
          class="image-container"
          [@categoryImageAnimation]="hoverCategories['map'] ? 'onHover' : 'onHide'"
        >
          <img loading="lazy" ngSrc="/home/map.jpg" alt="map" fill />
        </div>
      </section>
    </div>
  </div>
</div>
<!-- <div class="container m-auto">
        <app-instagram-feed></app-instagram-feed>
    </div> -->
}
